import React from 'react';
import { CHECKOUT_URL } from './constants';
interface CTAButtonProps {
  children: React.ReactNode;
  href?: string;
  className?: string;
  onClick?: () => void;
}
export function CTAButton({
  children,
  href = CHECKOUT_URL,
  className = '',
  onClick
}: CTAButtonProps) {
  const baseClasses = `
    inline-flex w-full items-center justify-center gap-2 rounded-xl bg-brand-blue px-4 py-3
    text-center text-sm font-extrabold uppercase leading-tight tracking-wide text-white shadow-lg shadow-brand-blue/20
    transition-all duration-200 hover:bg-brand-sky hover:shadow-xl active:translate-y-1 active:border-b-0
    border-b-4 border-brand-navy/40 sm:px-5 sm:text-base ${className}
  `;
  if (href) {
    return <a href={href} className={baseClasses} onClick={onClick} data-id="element-35" data-mp="2yre1x4stxq3j">
        {children}
      </a>;
  }
  return <button className={baseClasses} type="button" onClick={onClick} data-id="element-36" data-mp="3cqdp080p1wxl">
      {children}
    </button>;
}